/* ==========================================================================
   AJ FITS — Header runtime
   Sticky behaviour, rotating search keywords, predictive search,
   mega-menu keyboard access, mobile drawer.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var RECENT_KEY = 'aj_recent_searches_v1';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  /* =====================================================================
     <aj-header>
     ===================================================================== */
  class AJHeaderElement extends HTMLElement {
    connectedCallback() {
      this.initSticky();
      this.initKeywordRotator();
      this.initMegaMenu();
      this.search = new PredictiveSearch(this);
    }

    /* ---- Sticky + shrink ------------------------------------------- */
    initSticky() {
      if (this.dataset.sticky !== 'true') return;

      var self = this;
      var lastY = 0;
      var ticking = false;

      function update() {
        var y = window.scrollY;
        self.classList.toggle('is-stuck', y > 10);

        // Hide on scroll-down past the fold, reveal on scroll-up
        if (y > 400 && y > lastY && !self.classList.contains('is-search-open')) {
          self.classList.add('is-hidden');
        } else {
          self.classList.remove('is-hidden');
        }
        lastY = y;
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });

      update();
    }

    /* ---- Rotating search keywords ---------------------------------- */
    initKeywordRotator() {
      var rotator = $('[data-aj-kw-rotator]', this);
      if (!rotator || reduceMotion) return;

      var words = $$('.aj-hsearch__kw', rotator);
      if (words.length < 2) return;

      var i = 0;
      var self = this;

      this._kwTimer = setInterval(function () {
        // Pause while the shopper is actually typing
        if (self.classList.contains('is-search-open')) return;

        var current = words[i];
        var nextIndex = (i + 1) % words.length;
        var next = words[nextIndex];

        current.classList.add('is-leaving');
        current.classList.remove('is-active');
        next.classList.add('is-active');

        setTimeout(function () { current.classList.remove('is-leaving'); }, 360);
        i = nextIndex;
      }, 2600);
    }

    disconnectedCallback() {
      if (this._kwTimer) clearInterval(this._kwTimer);
    }

    /* ---- Mega menu: hover is CSS, this adds keyboard + touch -------- */
    initMegaMenu() {
      var items = $$('.aj-nav__item--has-mega', this);
      var self = this;

      items.forEach(function (item) {
        var link = $('.aj-nav__link', item);
        var mega = $('[data-aj-mega]', item);
        if (!link || !mega) return;

        // Keyboard: Enter/Space opens rather than navigating straight away
        link.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            if (!item.classList.contains('is-open')) {
              e.preventDefault();
              closeAll();
              item.classList.add('is-open');
              link.setAttribute('aria-expanded', 'true');
              var first = $('.aj-mega__link, .aj-mega__col-title', mega);
              if (first) first.focus();
            }
          }
        });

        // Touch: first tap opens the panel, second follows the link
        link.addEventListener('click', function (e) {
          if (!window.matchMedia('(hover: none)').matches) return;
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            closeAll();
            item.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
          }
        });

        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) {
            item.classList.remove('is-open');
            link.setAttribute('aria-expanded', 'false');
          }
        });
      });

      function closeAll() {
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var l = $('.aj-nav__link', i);
          if (l) l.setAttribute('aria-expanded', 'false');
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll();
      });

      document.addEventListener('click', function (e) {
        if (!self.contains(e.target)) closeAll();
      });
    }
  }

  /* =====================================================================
     Predictive search
     ===================================================================== */
  function PredictiveSearch(header) {
    this.header = header;
    this.panel = $('[data-aj-search-panel]', header);
    if (!this.panel) return;

    this.input = $('[data-aj-search-input]', header);
    this.inputMobile = $('[data-aj-search-input-mobile]', header);
    this.form = $('[data-aj-search-form]', header);
    this.idle = $('[data-aj-search-idle]', this.panel);
    this.loading = $('[data-aj-search-loading]', this.panel);
    this.results = $('[data-aj-search-results]', this.panel);
    this.empty = $('[data-aj-search-empty]', this.panel);
    this.footer = $('[data-aj-search-footer]', this.panel);
    this.viewAll = $('[data-aj-search-all]', this.panel);
    this.echo = $('[data-aj-search-echo]', this.panel);
    this.template = document.getElementById('AjSearchProductTemplate');

    this.abort = null;
    this.cache = {};
    this.isOpen = false;

    this.bind();
    this.renderRecent();
  }

  PredictiveSearch.prototype.bind = function () {
    var self = this;
    var onInput = debounce(function (e) { self.query(e.target.value); }, 220);

    [this.input, this.inputMobile].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', onInput);
      input.addEventListener('focus', function () { self.open(); });
      input.addEventListener('keydown', function (e) { self.onKeydown(e); });
    });

    // Keep the ghost placeholder in sync with the field's value
    if (this.input && this.form) {
      this.input.addEventListener('input', function () {
        self.form.classList.toggle('is-filled', self.input.value.length > 0);
      });
    }

    // Mobile: icon opens the full-screen sheet. The bottom bar is rendered from
    // theme.liquid, outside the header, so delegate from document rather than
    // scoping the lookup to this.header.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-aj-search-open]')) return;
      self.open();
      setTimeout(function () { if (self.inputMobile) self.inputMobile.focus(); }, 120);
    });

    $$('[data-aj-search-close]', this.panel).forEach(function (btn) {
      btn.addEventListener('click', function () { self.close(); });
    });

    // Trending / recent chips
    this.panel.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-aj-search-term]');
      if (!chip) return;
      var term = chip.dataset.ajSearchTerm;
      var target = self.inputMobile && self.inputMobile.offsetParent !== null ? self.inputMobile : self.input;
      if (target) {
        target.value = term;
        target.focus();
      }
      if (self.form) self.form.classList.add('is-filled');
      self.query(term);
    });

    var clear = $('[data-aj-clear-recent]', this.panel);
    if (clear) {
      clear.addEventListener('click', function () {
        try { localStorage.removeItem(RECENT_KEY); } catch (err) {}
        self.renderRecent();
      });
    }

    // Remember the term when a search is actually submitted
    $$('form[role="search"]', this.header).forEach(function (form) {
      form.addEventListener('submit', function () {
        var field = $('input[name="q"]', form);
        if (field && field.value.trim()) self.pushRecent(field.value.trim());
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen) self.close();
    });

    document.addEventListener('click', function (e) {
      if (!self.isOpen) return;
      if (self.panel.contains(e.target)) return;
      // The open trigger's own click also reaches document — don't close on it
      if (e.target.closest('[data-aj-search-open]')) return;
      if (self.header.contains(e.target) && e.target.closest('.aj-hsearch')) return;
      self.close();
    });
  };

  PredictiveSearch.prototype.open = function () {
    if (this.isOpen) return;
    this.isOpen = true;
    this.panel.hidden = false;
    this.header.classList.add('is-search-open');
    // An auto-hidden header carries transform: translateY(-100%), which makes it
    // the containing block for the panel's position:fixed — reveal it first so
    // the mobile sheet still measures against the viewport.
    this.header.classList.remove('is-hidden');
    if (this.input) this.input.setAttribute('aria-expanded', 'true');
    // Force a reflow so the entry transition runs
    void this.panel.offsetWidth;
    this.panel.classList.add('is-open');
    if (window.matchMedia('(max-width: 989px)').matches) {
      document.body.style.overflow = 'hidden';
    }
  };

  PredictiveSearch.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.panel.classList.remove('is-open');
    this.header.classList.remove('is-search-open');
    if (this.input) this.input.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    var panel = this.panel;
    setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 300);
  };

  PredictiveSearch.prototype.setState = function (state) {
    if (this.idle) this.idle.hidden = state !== 'idle';
    if (this.loading) this.loading.hidden = state !== 'loading';
    if (this.results) this.results.hidden = state !== 'results';
    if (this.empty) this.empty.hidden = state !== 'empty';
    if (this.footer) this.footer.hidden = state !== 'results';
  };

  PredictiveSearch.prototype.query = function (term) {
    var self = this;
    term = (term || '').trim();

    if (term.length < 2) {
      this.setState('idle');
      return;
    }

    this.open();

    if (this.viewAll) {
      this.viewAll.href = '/search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
    }

    if (this.cache[term]) {
      this.render(this.cache[term], term);
      return;
    }

    this.setState('loading');

    if (this.abort) this.abort.abort();
    this.abort = typeof AbortController !== 'undefined' ? new AbortController() : null;

    var url =
      (window.routes && window.routes.predictive_search_url ? window.routes.predictive_search_url : '/search/suggest') +
      '?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection,article,query' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,tag' +
      '&section_id=';

    fetch(url.replace('&section_id=', ''), {
      signal: this.abort ? this.abort.signal : undefined,
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Search failed');
        return r.json();
      })
      .then(function (data) {
        var resources = (data && data.resources && data.resources.results) || {};
        self.cache[term] = resources;
        self.render(resources, term);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        self.setState('idle');
      });
  };

  PredictiveSearch.prototype.render = function (res, term) {
    var products = res.products || [];
    var collections = res.collections || [];
    var queries = res.queries || [];
    var articles = res.articles || [];

    if (!products.length && !collections.length && !queries.length && !articles.length) {
      if (this.echo) this.echo.textContent = term;
      this.setState('empty');
      return;
    }

    var html = '';

    // Suggested completions — reads as the "smart" layer
    if (queries.length) {
      html += '<div class="aj-search-panel__group">';
      html += '<p class="aj-search-panel__label"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3c.4 3.6 2.1 5.3 5.7 5.7-3.6.4-5.3 2.1-5.7 5.7-.4-3.6-2.1-5.3-5.7-5.7C9.9 8.3 11.6 6.6 12 3Z"/><circle cx="18.5" cy="17.5" r="2.6"/><path d="M6 16.5h6"/></svg>Did you mean</p>';
      html += '<div class="aj-search-panel__chips">';
      queries.slice(0, 5).forEach(function (q) {
        html += '<a class="aj-pill aj-pill--sm" href="' + escapeHtml(q.url) + '">' + (q.styled_text || escapeHtml(q.text)) + '</a>';
      });
      html += '</div></div>';
    }

    if (collections.length) {
      html += '<div class="aj-search-panel__group">';
      html += '<p class="aj-search-panel__label">Collections</p>';
      html += '<div class="aj-search-panel__chips">';
      collections.slice(0, 6).forEach(function (c) {
        html += '<a class="aj-pill aj-pill--sm" href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a>';
      });
      html += '</div></div>';
    }

    if (products.length) {
      html += '<div class="aj-search-panel__group">';
      html += '<p class="aj-search-panel__label">Products</p>';
      html += '<div class="aj-search-panel__grid" data-products></div>';
      html += '</div>';
    }

    if (articles.length) {
      html += '<div class="aj-search-panel__group">';
      html += '<p class="aj-search-panel__label">Style journal</p>';
      html += '<div class="aj-search-panel__chips">';
      articles.slice(0, 4).forEach(function (a) {
        html += '<a class="aj-pill aj-pill--sm" href="' + escapeHtml(a.url) + '">' + escapeHtml(a.title) + '</a>';
      });
      html += '</div></div>';
    }

    this.results.innerHTML = html;

    // Products get built from the Liquid template so markup stays consistent
    var grid = $('[data-products]', this.results);
    if (grid && this.template) {
      var self = this;
      products.slice(0, 8).forEach(function (p) {
        var node = self.template.content.firstElementChild.cloneNode(true);
        node.href = p.url;

        var img = $('.aj-sresult__media img', node);
        var image = p.featured_image || {};
        if (image.url) {
          img.src = image.url.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
          img.alt = image.alt || p.title;
        } else {
          $('.aj-sresult__media', node).innerHTML = '';
        }

        $('.aj-sresult__title', node).innerHTML = highlight(p.title, term);
        $('.aj-sresult__price', node).textContent = formatMoney(p.price);

        var compare = $('.aj-sresult__compare', node);
        if (p.compare_at_price && Number(p.compare_at_price) > Number(p.price)) {
          compare.textContent = formatMoney(p.compare_at_price);
        } else {
          compare.remove();
        }

        grid.appendChild(node);
      });
    }

    this.setState('results');
  };

  PredictiveSearch.prototype.onKeydown = function (e) {
    if (!this.isOpen) return;
    var items = $$('.aj-sresult', this.panel);
    if (!items.length) return;

    var current = items.findIndex(function (i) { return i.classList.contains('is-highlighted'); });

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (current > -1) items[current].classList.remove('is-highlighted');
      var next = e.key === 'ArrowDown'
        ? (current + 1) % items.length
        : (current <= 0 ? items.length - 1 : current - 1);
      items[next].classList.add('is-highlighted');
      items[next].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && current > -1) {
      e.preventDefault();
      window.location.href = items[current].href;
    }
  };

  /* ---- Recent searches --------------------------------------------- */
  PredictiveSearch.prototype.pushRecent = function (term) {
    var list = this.readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
  };

  PredictiveSearch.prototype.readRecent = function () {
    try {
      var raw = localStorage.getItem(RECENT_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  };

  PredictiveSearch.prototype.renderRecent = function () {
    var wrap = $('[data-aj-recent-chips]', this.panel);
    var label = $('[data-aj-recent-label]', this.panel);
    if (!wrap || !label) return;

    var list = this.readRecent();
    if (!list.length) {
      label.hidden = true;
      wrap.innerHTML = '';
      return;
    }

    label.hidden = false;
    wrap.innerHTML = list
      .map(function (t) {
        return '<button class="aj-pill aj-pill--sm" type="button" data-aj-search-term="' + escapeHtml(t) + '">' + escapeHtml(t) + '</button>';
      })
      .join('');
  };

  /* ---- helpers ------------------------------------------------------ */
  function highlight(text, term) {
    var safe = escapeHtml(text);
    if (!term) return safe;
    try {
      var re = new RegExp('(' + term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      return safe.replace(re, '<mark>$1</mark>');
    } catch (e) {
      return safe;
    }
  }

  function formatMoney(value) {
    // Predictive search returns price in cents as a string
    var cents = typeof value === 'string' ? parseInt(value, 10) : value;
    if (isNaN(cents)) return '';
    if (window.AJ && window.AJ.formatMoney) return window.AJ.formatMoney(cents);
    return '₹' + (cents / 100).toFixed(0);
  }

  /* =====================================================================
     Mobile drawer
     ===================================================================== */
  function initDrawer() {
    var drawer = $('[data-aj-drawer]');
    if (!drawer) return;

    var panel = $('.aj-drawer__panel', drawer);
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      $$('[data-aj-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var closeBtn = $('.aj-drawer__close', drawer);
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      $$('[data-aj-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.removeEventListener('keydown', onKeydown);
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 520);
      if (lastFocused) lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') return close();
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input, select, textarea', panel)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    $$('[data-aj-drawer-open]').forEach(function (btn) { btn.addEventListener('click', open); });
    $$('[data-aj-drawer-close]', drawer).forEach(function (btn) { btn.addEventListener('click', close); });

    /* Accordion sub-menus.

       An open panel rests at height:auto so it can grow with its content, but
       animating away from `auto` does nothing — the browser has no start value
       to interpolate from. So collapsing always pins the measured pixel height
       for one frame first. */
    function collapse(panel) {
      if (!panel) return;
      panel.style.height = panel.scrollHeight + 'px';
      // Force a reflow so the pinned height is the transition's start value
      void panel.offsetHeight;
      panel.style.height = '0px';
    }

    function expand(panel) {
      if (!panel) return;
      panel.style.height = panel.scrollHeight + 'px';
      panel.addEventListener('transitionend', function done(e) {
        if (e.target !== panel || e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', done);
        // Only settle to auto if it is still open
        if (panel.style.height !== '0px') panel.style.height = 'auto';
      });
    }

    function closeItem(item) {
      if (!item || !item.classList.contains('is-open')) return;
      item.classList.remove('is-open');
      var b = $('[data-aj-drawer-toggle]', item);
      if (b) b.setAttribute('aria-expanded', 'false');
      collapse($('[data-aj-drawer-sub]', item));

      // Anything opened inside it closes too, so it reopens clean
      $$('.aj-drawer__group.is-open', item).forEach(function (g) {
        g.classList.remove('is-open');
        var gb = $('[data-aj-drawer-group-toggle]', g);
        if (gb) gb.setAttribute('aria-expanded', 'false');
        var gp = $('[data-aj-drawer-group-panel]', g);
        if (gp) gp.style.height = '0px';
      });
    }

    $$('[data-aj-drawer-toggle]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.aj-drawer__nav-item');
        var sub = $('[data-aj-drawer-sub]', item);
        var isOpen = item.classList.contains('is-open');

        // Only one branch open at a time keeps the drawer scannable
        $$('.aj-drawer__nav-item.is-open', drawer).forEach(function (other) {
          if (other !== item) closeItem(other);
        });

        if (isOpen) {
          closeItem(item);
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          expand(sub);
        }
      });
    });

    /* Second level — the category groups inside an open branch. These start
       closed so a long menu like Kurtis opens to a short, scannable list. */
    $$('[data-aj-drawer-group-toggle]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.aj-drawer__group');
        var panel = $('[data-aj-drawer-group-panel]', group);
        var parentSub = btn.closest('[data-aj-drawer-sub]');
        var isOpen = group.classList.contains('is-open');

        $$('.aj-drawer__group.is-open', parentSub || drawer).forEach(function (other) {
          if (other === group) return;
          other.classList.remove('is-open');
          var ob = $('[data-aj-drawer-group-toggle]', other);
          if (ob) ob.setAttribute('aria-expanded', 'false');
          collapse($('[data-aj-drawer-group-panel]', other));
        });

        if (isOpen) {
          group.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          collapse(panel);
        } else {
          group.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          expand(panel);
        }

        // The branch above has to grow or shrink to match
        if (parentSub) parentSub.style.height = 'auto';
      });
    });
  }

  /* =====================================================================
     Announcement bar rotator
     ===================================================================== */
  function initAnnounceRotator() {
    $$('[data-aj-rotator]').forEach(function (rotator) {
      var slides = $$('.aj-announce__slide', rotator);
      if (slides.length < 2 || reduceMotion) return;
      var interval = (parseInt(rotator.dataset.interval, 10) || 4) * 1000;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, interval);
    });
  }

  /* =====================================================================
     Boot
     ===================================================================== */
  if (!customElements.get('aj-header')) {
    customElements.define('aj-header', AJHeaderElement);
  }

  function boot() {
    initDrawer();
    initAnnounceRotator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
